import { KatalisTranslationEnums } from '../translations.interface';

const messages: KatalisTranslationEnums = {
  LocalAmostraLogEnum: {
    GUARULHOS: 'Guarulhos',
    UTINGA: 'Utinga',
    VILA_GUILHERME: 'Vila Guilherme',
  },
  EtapaAmostraLogEnum: {
    CADASTRO_COMERCIAL: 'CADASTRO_COMERCIAL',
    CADASTRO_GUARULHOS: 'CADASTRO_GUARULHOS',
    CADASTRO_UTINGA: 'CADASTRO_UTINGA',
    COLETA_LABORATORIO: 'COLETA_LABORATORIO',
    ANALISE_LABORATORIO: 'ANALISE_LABORATORIO',
    ENVIO_LABORATORIO: 'ENVIO_LABORATORIO',
    ENVIO_LABORATORIO_GUARULHOS: 'ENVIO_LABORATORIO_GUARULHOS',
    FINALIZACAO: 'FINALIZACAO',
    REANALISE: 'REANALISE',
    RECEBIMENTO_LABORATORIO: 'RECEBIMENTO_LABORATORIO',
    RECEBIMENTO_LABORATORIO_GUARULHOS: 'RECEBIMENTO_LABORATORIO_GUARULHOS',
    RECEBIMENTO_PRODUCAO: 'RECEBIMENTO_PRODUCAO',
    SOLICITACAO_ANALISE: 'SOLICITACAO_ANALISE',
  },
  TipoAmostraEnum: {
    CARVAO: 'Carvão',
    CATALISADOR: 'Catalisador',
    ESCORIA: 'Escória',
    MINERIO: 'Minério',
    OUTROS: 'Outros',
    PLACA: 'Placa eletrônica',
  },
  EtapaAmostraLogEnumStatus: {
    ANALISE_LABORATORIO: 'Em análise - Matriz',
    ANALISE_LABORATORIO_GUARULHOS: 'Em análise - Guarulhos',
    CADASTRO_COMERCIAL: 'Entrada na produção - Comercial',
    CADASTRO_GUARULHOS: 'Entrada na produção - Guarulhos',
    CADASTRO_UTINGA: 'Entrada na produção - Utinga',
    COLETA_LABORATORIO: 'Recebida no Laboratório - Matriz',
    ENVIO_LABORATORIO: 'Aguardando recebimento - Matriz',
    ENVIO_LABORATORIO_GUARULHOS: 'Aguardando recebimento - Guarulhos',
    FINALIZACAO: 'Finalizada',
    REANALISE: 'Reanálise',
    RECEBIMENTO_LABORATORIO: 'Recebida no Laboratório - Matriz',
    RECEBIMENTO_LABORATORIO_GUARULHOS: 'Recebida no Laboratório - Guarulhos',
    RECEBIMENTO_PRODUCAO: 'Entrada na produção - Matriz',
    SOLICITACAO_ANALISE: 'Análise solicitada - Guarulhos',
  },
  TipoEnsaioEnum: {
    CALCINACAO: 'Calcinação',
    CARBONO: 'Carbono',
    FRX: 'FRX',
    ICP: 'ICP',
    UMIDADE: 'Umidade',
  },
  StatusAmostraEnsaioEnum: {
    AGUARDANDO_FIRE_ASSAY: 'Aguardando Fire Assay',
    AGUARDANDO_PESAGEM_DILUICAO: 'Aguardando pesagem/diluição',
    AGUARDANDO_ANALISE_ICP: 'Aguardando análise de ICP',
    AGUARDANDO_ANALISE_ICP_COBRE: 'Aguardando análise de ICP Cobre',
    AGUARDANDO_PESAGEM_PEROLA: 'Aguardando pesagem da pérola',
    AGUARDANDO_ANALISE_UMIDADE: 'Aguardando análise de umidade',
    PENDENTE: 'Pendente',
  },
  CategoriaEnsaioAliquotaEnum: {
    PULP: 'Pulp',
    METALLIC: 'Metallic',
  },
  UtilizacaoBalancasEnum: {
    CALCINACAO: 'Calcinação',
    FIRE_ASSAY: 'Fire Assay',
    GRAVIMETRIA: 'Gravimetria',
    ICP_COBRE: 'ICP Cobre',
    ICP: 'ICP',
    UMIDADE_BALANCA: 'Umidade',
  },
};

export default messages;
